import React from 'react';

export default function AboutCards() {
  const cards = [
    {
      title: 'embrace diversity',
      text: 'Give space for groups historically left out.',
      icon: require('../../assets/icons/embrace-diversity-icon.png'),
      width: 'w-[346px] lg:w-[400px] 2xl:ml-28',
      background: require('../../assets/img/about/bg-embrace-diversity.png')
    },
    {
      title: 'be innovative',
      text: 'Always look for ways to make it better.',
      icon: require('../../assets/icons/be-innovative-icon.png'),
      width: 'w-[346px] lg:w-[400px] 2xl:mr-28',
    },
    {
      title: 'develop collaboration',
      text: 'Work with communities to develop together.',
      icon: require('../../assets/icons/develop-collaboration-icon.png'),
      width: 'w-[346px] md:1/4',
      background: require('../../assets/img/about/bg-develop.png')
    },
    {
      title: 'be sensitive',
      text: 'Don’t forget the impact of past injustices.',
      icon: require('../../assets/icons/be-sensitive-icon.png'),
      width: 'w-[346px] md:1/4',
    },
    {
      title: 'give back',
      text: 'Always find ways to support communities.',
      icon: require('../../assets/icons/give-back-icon.png'),
      width: 'w-[346px] md:1/4',
      background: require('../../assets/img/about/bg-give-back.png')
    },

  ]
  return (
    <section className="container mx-auto px-4 lg:px-24 flex flex-row flex-wrap justify-center gap-4 pb-12 lg:pb-40">
      {
        cards.map((card) => (
          <div
            className={`bg-dark-denim flex items-center h-40 py-4 pl-5 pr-6 rounded-lg gap-6 bg-cover ${card.width}`}
            key={card.title}
            style={{ backgroundImage: `url(${card.background})` }}
          >
            <img src={card.icon} alt="" className="w-12"/>
            <div className="text-white text-xl">
              <h4 className="with-line-above before:w-16 mb-5 text-2xl font-semibold">{ card.title }</h4>
              <p className="text-sm">{ card.text }</p>
            </div>
          </div>
        ))
      }
    </section>
  )
}